import netsSip from './nets-sip';

export default angular
  .module('app.sip', [])
  .component('netsSip', netsSip);
